import React, { useState, useEffect } from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import TextField from "@material-ui/core/TextField";

import SearchIcon from "@material-ui/icons/Search";


// @material-ui/lab
import Autocomplete from "@material-ui/lab/Autocomplete";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  textField: {
    backgroundColor: "ghostwhite",
    margin: "8px 0",
  },
}));

const SelectInput = (props) => {
  const { defaultValue, options, onSelect } = props;
  const classes = useStyles();
  const [value, setValue] = useState(null);
  const [inputValue, setInputValue] = useState("");

  return (
    <Autocomplete
      value={value ? value : defaultValue ? defaultValue : null}
      inputValue={inputValue}
      onChange={(event, newValue) => {
        setValue(newValue);
        onSelect(event, newValue);
      }}
      onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
      id="query"
      options={options}
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Search"
          variant="outlined"
          className={classes.textField}
          // inputProps={{
          //     className: classes.input
          // }}
          InputProps={{
                  startAdornment: <SearchIcon />,
                  classes: {
                    adornedStart: props.classes.adornedStart,
                    inputAdornedStart: props.classes.inputAdornedStart,
                    root: props.classes.root
                  }
                }}
          margin="dense"
        />
      )}
    />
  );
};

export default SelectInput;



// WEBPACK FOOTER //
// ./src/components/Search/Autocomplete.jsx